import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {
  useMediaVideoActualSizeDisplay,
  useShouldShowMediaVideoActualSizeResetAtLevel,
} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const OriginalSize = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const videoActualSize = useMediaVideoActualSizeDisplay(
    settingsLevel,
    panelRef
  );
  const isSetAtLevel = useShouldShowMediaVideoActualSizeResetAtLevel(
    settingsLevel,
    panelRef
  );
  // Local state only smooths the switch animation; it stays in sync with the
  // cascaded value because makeOriginalSizeComponentKeySelector remounts this
  // component whenever that value changes.
  const [shouldUseOriginalSize, setShouldUseOriginalSize] =
    useState(videoActualSize);
  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Use original video size"
        configField="videoActualSize"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('videoActualSize')}
      />
      <Switch.Root
        aria-label="Toggle use original video size"
        data-test="original-size-switch"
        checked={shouldUseOriginalSize}
        onCheckedChange={newValue => {
          setShouldUseOriginalSize(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            updateConfig({videoActualSize: newValue});
          }, 100);
        }}>
        <Switch.Thumb checked={shouldUseOriginalSize} />
      </Switch.Root>
    </div>
  );
};
